/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type BaseResponse,
	BaseResponseFromJSON,
	BaseResponseToJSON,
} from '../models/BaseResponse';
import {
	type SetPrivacyDataAcceptedDateResponse,
	SetPrivacyDataAcceptedDateResponseFromJSON,
	SetPrivacyDataAcceptedDateResponseToJSON,
} from '../models/SetPrivacyDataAcceptedDateResponse';

export interface ApiV1SetPrivacyDataAcceptedDateGetRequest {
	caseId: string;
}

/**
 *
 */
export class CheckPointApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV1SetPrivacyDataAcceptedDateGet without sending the request
	 */
	async apiV1SetPrivacyDataAcceptedDateGetRequestOpts(
		requestParameters: ApiV1SetPrivacyDataAcceptedDateGetRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV1SetPrivacyDataAcceptedDateGet().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/setPrivacyDataAcceptedDate`;

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1SetPrivacyDataAcceptedDateGetRaw(
		requestParameters: ApiV1SetPrivacyDataAcceptedDateGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<SetPrivacyDataAcceptedDateResponse>> {
		const requestOptions =
			await this.apiV1SetPrivacyDataAcceptedDateGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			SetPrivacyDataAcceptedDateResponseFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV1SetPrivacyDataAcceptedDateGet(
		requestParameters: ApiV1SetPrivacyDataAcceptedDateGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<SetPrivacyDataAcceptedDateResponse> {
		const response = await this.apiV1SetPrivacyDataAcceptedDateGetRaw(
			requestParameters,
			initOverrides
		);
		return await response.value();
	}
}
